function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.637,
    height: 38.607,
    viewBox: "0 0 42.637 38.607",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 10800",
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 10799"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 10798",
    transform: "translate(1.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 1974",
    width: 32.373,
    height: 40.136,
    rx: 3.927,
    transform: "rotate(89.998 17.577 22.56)",
    style: {
      stroke: "#727272",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "#fff",
      strokeWidth: "2.5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 10797"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 7489",
    d: "M1363.1 480.582v-6.575a1.722 1.722 0 0 1 1.6-1.823 1.723 1.723 0 0 1 1.6 1.823v6.575a1.722 1.722 0 0 1-1.6 1.823 1.722 1.722 0 0 1-1.6-1.823z",
    transform: "translate(-1331.273 -472.184)",
    style: {
      fill: "#727272"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 7490",
    d: "M1330.149 480.582v-6.575a1.721 1.721 0 0 1 1.6-1.823 1.721 1.721 0 0 1 1.6 1.823v6.575a1.721 1.721 0 0 1-1.6 1.823 1.722 1.722 0 0 1-1.6-1.823z",
    transform: "translate(-1325.024 -472.184)",
    style: {
      fill: "#727272"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 212",
    transform: "translate(1.25 13.175)",
    style: {
      stroke: "#727272",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "#fff",
      strokeWidth: "2.5px"
    },
    d: "M0 0h40.136"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 7491",
    d: "m1341.755 501.4 3.871 6.307 9.344-10.618",
    transform: "translate(-1326.301 -477.609)",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "#727272",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.50ac8f16.svg";
export { ForwardRef as ReactComponent };